import {
  PublicSessionOrganizationMemberRole,
  ZalamoObject,
} from '../../../../../zalamo-support/src/graphql';

export interface TabloGroupConfig {
  leadingChildId?: string;
  isPhotoOnly?: boolean;
  isNameOnly?: boolean;
  hideLeadingChild?: boolean;
  itemsPerRow: number;
  addSpine: boolean;
  spineSize: number;
  notAttendants: string[];
  attendants?: string[];
  align: 'left' | 'center' | 'right';
  sideMargin: number;
  childVerticalMargin: number;
  childHorizontalMargin: number;
  nameHandling: 'split' | 'join' | 'firstNameOnly' | 'incognito';
  childConfigDifferenceRule: 'none' | 'oddEven' | 'oddEvenRow';
  photoAsCircle: boolean;
  photoAsSquare: boolean;
  maximizePhoto?: boolean;
  childNameTilt: number;
  childTilt: number;
  childPositionDistortion: number;
  childFirstNameMaxFontSize: number;
  childLastNameMaxFontSize: number;
  childFirstNameHeight: number;
  childLastNameHeight: number;
  childNamesGap: number;
  uppercase?: boolean;
  uppercaseOdd?: boolean;
  uppercaseEven?: boolean;
  font: {
    fileName: string;
    fontId: string;
  };
  fontOdd: {
    fileName: string;
    fontId: string;
  };
  fontEven: {
    fileName: string;
    fontId: string;
  };
  fontLatterSpacing: number;
  fontLatterSpacingOdd: number;
  fontLatterSpacingEven: number;
  childFrameWidth: number;
  childFrameWidthOdd: number;
  childFrameWidthEven: number;
  childFrameColor: string;
  childFrameColorOdd: string;
  childFrameColorEven: string;
  photoAsBackground: boolean;
  photoSideMargins: number;
  photoSideMarginsOdd: number;
  photoSideMarginsEven: number;
  childPhotoFrameWidth: number;
  childPhotoFrameWidthOdd: number;
  childPhotoFrameWidthEven: number;
  childPhotoFrameColor: string;
  childPhotoFrameColorOdd: string;
  childPhotoFrameColorEven: string;
  childNameFrameWidth: number;
  childNameFrameWidthOdd: number;
  childNameFrameWidthEven: number;

  childNameBackgroundFile?: string;
  childNameBackgroundFileOdd?: string;
  childNameBackgroundFileEven?: string;

  childNameFrameRadius: number;
  childNameFrameRadiusOdd: number;
  childNameFrameRadiusEven: number;

  childNameBackgroundColor: string;
  childNameBackgroundColorOdd: string;
  childNameBackgroundColorEven: string;
  childNameNameFrameColor: string;
  childNameNameFrameColorOdd: string;
  childNameNameFrameColorEven: string;
  childPhotoNameToPhotoGap: number;

  childPhotoOverlayFileName: string;
  childPhotoOverlayFileNameEven: string;
  childPhotoOverlayFileNameOdd: string;
  childPhotoOverlayHasColorOverlay: boolean;
  childPhotoOverlayHasColorOverlayEven: boolean;
  childPhotoOverlayHasColorOverlayOdd: boolean;
  childPhotoOverlayColorOverlay: string;
  childPhotoOverlayColorOverlayEven: string;
  childPhotoOverlayColorOverlayOdd: string;
  childPhotoOverlayScale: number;
  childPhotoOverlayScaleEven: number;
  childPhotoOverlayScaleOdd: number;
  childPhotoNameFontColor: string;
  childPhotoNameFontColorOdd: string;
  childPhotoNameFontColorEven: string;
  childNameSideMargins: number;
  childNameSideMarginsOdd: number;
  childNameSideMarginsEven: number;
  childBackgroundColor: string;
  childBackgroundColorOdd: string;
  childBackgroundColorEven: string;

  photoRadius: number;
  photoRadiusOdd: number;
  photoRadiusEven: number;
  childPhotoShadow: string;
  childPhotoShadowOdd: string;
  childPhotoShadowEven: string;

  childShadow: string;
  childShadowOdd: string;
  childShadowEven: string;

  childRadius: number;
  childRadiusOdd: number;
  childRadiusEven: number;
  showDirectors?: boolean;
  directorsGoFirst?: boolean;
  singleChildConfig?: Record<
    number,
    {
      x: number;
      y: number;
      childFrameWidth: number;
      childFrameColor: string;
      photoAsBackground: boolean;
      photoSideMargins: number;
      childPhotoFrameWidth: number;
      childPhotoFrameColor: string;
      childNameFrameWidth: number;
      childNameBackgroundFile?: string;
      childNameFrameRadius: number;
      childNameBackgroundColor: string;
      childNameNameFrameColor: string;
      childPhotoNameToPhotoGap: number;
      childPhotoOverlayFileName: string;
      childPhotoOverlayHasColorOverlay: boolean;
      childPhotoOverlayColorOverlay: string;
      childPhotoNameFontColor: string;
      childNameSideMargins: number;
      childBackgroundColor: string;
      photoRadius: number;
      childShadow: string;
      childPhotoShadow: string;
      childRadius: number;
      transform: string;
      nameHandling: 'split' | 'join';
      photoAsCircle: boolean;
      photoAsSquare: boolean;
      childNameTilt: number;
      childTilt: number;
      childPositionDistortion: number;
      childFirstNameMaxFontSize: number;
      childLastNameMaxFontSize: number;
      childFirstNameHeight: number;
      childLastNameHeight: number;
    }
  >;
}

export interface TabloStaticPhotoConfig {
  sideMargin: number;
  photoAsCircle: boolean;
  photoAsSquare: boolean;
  childTilt: number;
  childPhotoFrameWidth: number;
  childPhotoFrameColor: string;
  childPhotoOverlayFileName: string;
  childPhotoOverlayScale: number;

  childPhotoShadow: string;
  childRadius: number;
  photoId: string;
  photoGroupId: string;
  fileName: string;
  x: number;
  y: number;
  scale: number;
  schoolPhotoNumber: number;
  width: number;
  height: number;
}

export interface TabloSinglePage {
  url: string | null;
  background?: TabloPageBackgroundConfig;
  backgroundImageSize?: TabloPageBackgroundImageSize | null;
}

export interface TabloPageBackgroundConfig {
  x: number;
  y: number;
  scale: number;
}

export interface TabloPageBackgroundImageSize {
  width: number;
  height: number;
}

export enum TabloGroupMemberType {
  teacher = 'teacher',
  student = 'student',
  leadingChild = 'leadingChild',
}

export interface TabloMemberList {
  label: string;
  members: TabloMember[];
  id: string;

  type: TabloGroupMemberType;
}

export interface TabloMember {
  firstName: string;
  lastName: string;
  photoId?: string;
  roles: PublicSessionOrganizationMemberRole[];
  groupRoles?: string[];
  tabloMemberId: string;
  nameTilt?: number;
  childTilt?: number;
  childPositionDistortion?: {
    x: number;
    y: number;
  };
  childNameTiltLast?: number;
  childTiltLast?: number;
  childPositionDistortionLast?: number;
  childOriginTransform?: {
    x: number;
    y: number;
  };
  index?: number;
  avatar?: string;
  x?: number;
  rotation?: number;
}

export interface TabloGroupElementConfig {
  type: 'group';
  config: TabloElementGroupList;
  isLeadingChild?: boolean;
  id: string;
  editMode: boolean;
  isOnHover: boolean;
  rotation: number;
}

export interface TabloText {
  type: 'text';
  config: TabloTextConfig;
  id: string;
  editMode: boolean;
  isOnHover: boolean;
}

export interface TabloStaticText {
  type: 'statictext';
  config: TabloStaticTextConfig;
  id: string;
  editMode: boolean;
  isOnHover: boolean;
  overflowError?: boolean;
}
export interface TabloQrConfigHost {
  type: 'qr';
  config: TabloQrConfig;
  id: string;
  editMode: boolean;
  isOnHover: boolean;
  overflowError?: boolean;
}

export interface TabloCustomGraphic {
  type: 'graphic';
  id: string;
  editMode: boolean;
  isOnHover: boolean;
  config: TabloCustomGraphicConfig;
}

export interface TabloPhotoOfSchool {
  type: 'photoOfSchool';
  id: string;
  editMode: boolean;
  isOnHover: boolean;
  config: TabloPhotoOfSchoolConfig;
}

export interface TabloCustomGraphicConfig {
  fileName: string;
  transform: string;
  x: number;
  y: number;
  width: number;
  height: number;
  hidden: boolean;
  locked?: boolean;
  index: number;
  config: StaticGraphicConfig;
}
export interface StaticGraphicConfig {
  opacity: number;
  hasColorOverlay?: boolean;
  colorOverlay?: string;
  hasShadow?: boolean;
  cssShadowFilter?: string;
}

export interface TabloPhotoOfSchoolConfig {
  source: 0 | 1 | 2;
  transform: string;
  x: number;
  y: number;
  width: number;
  height: number;
  hidden: boolean;
  locked?: boolean;
  index: number | null;
  config: TabloStaticPhotoConfig;
}

export interface TabloLogoElementConfig {
  x: number;
  y: number;
  width: number;
  height: number;
  fileName: string;
  rotation: number;
  transform: string;
  index: number;
  hidden?: boolean;
  locked?: boolean;
  config: { opacity: number };
}

export interface TabloLogoElement {
  type: 'logo' | 'photographerLogo';
  id: string;
  editMode: boolean;
  config: TabloLogoElementConfig;
  isOnHover: boolean;
}

export type TabloStructureElementForAdd<T> = Omit<
  T,
  'id' | 'editMode' | 'isOnHover'
>;

/* -------------------------------------------------------
 * 1.  MAPA  "nazwę‑typu"  →  "interfejs CONFIG"
 * ----------------------------------------------------- */
interface TabloConfigMap {
  group: TabloElementGroupList;
  text: TabloTextConfig;
  qr: TabloQrConfig;
  statictext: TabloStaticTextConfig;
  graphic: TabloCustomGraphicConfig;
  photoOfSchool: TabloPhotoOfSchoolConfig;
  /* logo i photographerLogo mają tę samą strukturę konf.  */
  logo: TabloLogoElementConfig;
  photographerLogo: TabloLogoElementConfig;
  leadingChild: TabloLeadingChildConfigDetails;
  leadingChildPhoto: TabloLeadingChildPhotoConfigDetails;
  leadingChildName: TabloLeadingChildNameConfigDetails;
  staticChildPhoto: TabloStaticChildPhotoConfig;
}

/* -------------------------------------------------------
 * 2.  POLA WSPÓLNE  (plus warunkowe dodatki)
 * ----------------------------------------------------- */
export type TabloElementBase<K extends keyof TabloConfigMap> = {
  /* klucz rozróżniający */
  type: K;

  id: string;
  editMode: boolean;
  isOnHover: boolean;

  /* właściwy interfejs config */
  config: TabloConfigMap[K];

  /* ———  pola opcjonalne/dodatkowe  ——— */
} /* tylko wybrane typy mają rotation */ & (K extends 'group' | 'leadingChild'
  ? { rotation: number }
  : {}) &
  /* tylko group dostaje isLeadingChild */
  (K extends 'group' ? { isLeadingChild?: boolean } : {});

/* -------------------------------------------------------
 * 3.  ROZWINIĘCIE MAPY  →  DISCRIMINATED UNION
 * ----------------------------------------------------- */
export type TabloStructoreElement = {
  [K in keyof TabloConfigMap]: TabloElementBase<K>;
}[keyof TabloConfigMap];

export interface TabloStaticChildPhoto {
  type: 'staticChildPhoto';
  id: string;
  editMode: boolean;
  isOnHover: boolean;
  config: TabloStaticChildPhotoConfig;
}

export interface TabloStaticChildPhotoConfig {
  x: number;
  y: number;
  width: number;
  height: number;
  photoId: string;
  groupId: string;
  rotation: number;
  transform: string;
  index: number;
  hidden?: boolean;
  locked?: boolean;
  config: TabloStaticPhotoConfig;
}

export interface TabloLeadingChildConfigDetails {
  childId: string;
  x: number;
  y: number;
  width: number;
  height: number;
  config: TabloGroupConfig;
  isLeadingChild: boolean;
  rotation: number;
  transform: string;
  index: number;
  hidden?: boolean;
  locked?: boolean;
}

export interface TabloLeadingChildPhotoConfigDetails {
  childId: string;
  x: number;
  y: number;
  width: number;
  height: number;
  config: TabloGroupConfig;
  isLeadingChild: boolean;
  rotation: number;
  transform: string;
  index: number;
  hidden?: boolean;
  locked?: boolean;
}

export interface TabloLeadingChildNameConfigDetails {
  childId: string;
  x: number;
  y: number;
  width: number;
  height: number;
  config: TabloGroupConfig;
  isLeadingChild: boolean;
  rotation: number;
  transform: string;
  index: number;
  hidden?: boolean;
  locked?: boolean;
}

export interface LeadingChildConfig {
  type: 'leadingChild';
  config: TabloLeadingChildConfigDetails;
  id: string;
  editMode: boolean;
  isOnHover: boolean;
}

export type TabloProjectStructure = Array<TabloStructoreElement>;

export interface TabloPageStructureUpdate {
  page: number;
  structure: TabloProjectStructure;
}

export interface TabloTextConfigOptions {
  text: string;
  fontSize: number;
  align: 'left' | 'center' | 'right';
  verticalAlign: 'top' | 'center' | 'bottom';
  color: string;
  font: {
    fileName: string;
    fontId: string;
  };
  fontLatterSpacing: number;
  addYearToGroupName: boolean;
  beforeText: string;
  afterText: string;
  pickedNameSource: SchoolNameSource;
  uppercase?: boolean;
}

export enum SchoolNameSource {
  Classic = 'classic',
  Official = 'official',
  Short = 'short',
}

export interface TabloStaticTextConfigOptions {
  text: string;
  fontSize: number;
  align: 'left' | 'center' | 'right';
  verticalAlign: 'top' | 'center' | 'bottom';
  color: string;
  font: {
    fileName: string;
    fontId: string;
  };
  fontLatterSpacing: number;
  headerFontSize: number;
  headerAlign: 'left' | 'center' | 'right';
  headerColor: string;
  headerFont: {
    fileName: string;
    fontId: string;
  };
  headerFontLatterSpacing: number;
  background: string;
  borderRadius: number;
  padding: number;
  uppercase?: boolean;
  headerUppercase?: boolean;
}

export interface TabloTextConfig {
  source: ZalamoObject;
  officialName?: string;
  shortName?: string;
  config: TabloTextConfigOptions;
  x: number;
  y: number;
  width: number;
  height: number;
  rotation: number;
  transform: string;
  index: number;
  hidden?: boolean;
  locked?: boolean;
}

export interface TabloQrConfig {
  x: number;
  y: number;
  width: number;
  height: number;
  rotation: number;
  transform: string;
  index: number;
  hidden?: boolean;
  locked?: boolean;
  config: {};
}

export interface TabloStaticTextConfig {
  config: TabloStaticTextConfigOptions;
  x: number;
  y: number;
  width: number;
  height: number;
  rotation: number;
  transform: string;
  index: number;
  hidden?: boolean;
  locked?: boolean;
}

export interface TabloElementGroupList {
  id: string;
  list: TabloMemberList;
  imagesSource: string[];
  handPicked: Record<
    string,
    {
      photoId: string;
      crop: [number, number, number, number];
    }
  >;
  placeholders: TabloPlaceHolder[];
  x: number;
  y: number;
  width: number;
  height: number;
  config: TabloGroupConfig;
  rotation: number;
  transform: string;
  index: number;
  hidden?: boolean;
  locked?: boolean;
}

export interface TabloPlaceHolder {
  index: number;
  size: number;
}

export interface TabloFaceToPerson {
  x: number;
  y: number;
  photoId: string;
  groupId: string;
  width: number;
  height: number;
  scale: number;
  rotation: number;
}

/** All recognised validation‑error categories */
export type TabloProjectValidationReasonKind =
  | 'font'
  | 'memberPhoto'
  | 'logo'
  | 'statictextFont'
  | 'groupConfig'
  | 'statictextOverflow'
  | 'missingSchoolPhoto'
  | 'missingQR'
  | 'missingChildPhoto'
  | 'emptyGroup'
  | 'backgroundDpi';

// → Add more kinds here as new rules are introduced

/** A single concrete reason explaining why something is invalid */
export interface TabloProjectValidationReason {
  /** Machine‑readable category */
  type: TabloProjectValidationReasonKind;
  /** Human‑readable explanation shown to the user */
  reason: string;
  /** Optional IDs that help the UI link the error to a specific element */
  elementId?: string;
  memberId?: string;
}

/** Validation result for one page */
export interface TabloProjectPageValidationStatus {
  isValid: boolean;
  reasons: TabloProjectValidationReason[];
}

/** Whole‑project validation report */
export interface TabloProjectValidationStatus {
  isValid: boolean;
  pages: TabloProjectPageValidationStatus[];
  global: TabloProjectValidationReason[];
}
